// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__mdxEs","input":"style_input__vn-sU","inputLabel":"style_inputLabel__DsI+a"};